<div class="flex flex-col gap-6">
  <p-card>
    <ng-template pTemplate="header">
      <div class="px-4 pt-4">
        <h3 class="text-lg font-semibold m-0">Anmeldeverlauf</h3>
        <p class="text-sm text-surface-500 dark:text-surface-400 mt-1">Übersicht deiner letzten Anmeldeversuche</p>
      </div>
    </ng-template>

    <p-table [value]="loginAttempts" [tableStyle]="{ 'min-width': '100%' }">
      <ng-template pTemplate="header">
        <tr>
          <th>Status</th>
          <th>Datum</th>
          <th>Uhrzeit</th>
          <th>IP-Adresse</th>
          <th>Browser</th>
          <th>Betriebssystem</th>
          <th>Sprache</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-attempt>
        <tr>
          <td>
            @if (attempt.successful) {
              <p-tag value="Erfolgreich"/>
            } @else {
              <p-tag value="Fehlgeschlagen" severity="danger"/>
            }
          </td>
          <td>{{ formatDate(attempt.timestamp) }}</td>
          <td>{{ formatTime(attempt.timestamp) }}</td>
          <td class="font-mono text-sm">{{ attempt.ipAddress }}</td>
          <td>{{ parseBrowser(attempt.userAgent) }}</td>
          <td>{{ parseOS(attempt.userAgent) }}</td>
          <td>{{ attempt.browserLanguage }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7">
            <div class="text-center py-8 text-surface-500 dark:text-surface-400">
              <zaeper-icon fontSet="material-icons-outlined" class="text-4xl mb-2">history</zaeper-icon>
              <p>Keine Anmeldeversuche vorhanden</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>
